import React from 'react';
import { createGlobalState } from 'react-hooks-global-state';

const initialState = { 
    loading: false,
    books: true,
    testimonials: true,
    video: true,
    team: true
 };
const { useGlobalState } = createGlobalState(initialState);

export {useGlobalState}